const autoNgTemplateLoaderTemplate1 = require('./edgeJob.html');

import angular from 'angular';
import { EdgeJobController } from './edgeJobController';

angular.module('portainer.edge').component('edgeJobView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: EdgeJobController,
});
